import { fetchInterestRates } from '@hex/calculators-shared/api';
import { useSapphireMedia } from '@hex/calculators-shared/hooks';
import { BaseLayout, FormLayout, ResultLayout } from '@hex/calculators-shared/layout';
import { InterestRatesRequest, InterestRatesResponse } from '@hex/calculators-shared/types';
import { getPartnership } from '@hex/calculators-shared/utils';
import { trackCalculatorSubmit } from '@hex/shared/tracking';
import { useRef, useState } from 'react';
import type { UseFormReset } from 'react-hook-form';
import { Form } from './Form';
import { Results } from './Results';

export function InterestRateCalculator() {
  const [responseData, setResponseData] = useState<InterestRatesResponse | null>(null);
  const [hasError, setHasError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);
  const { isExtraSmall, isSmall } = useSapphireMedia();
  const buttonRef = useRef<HTMLButtonElement>(null);

  async function onSubmit(data: InterestRatesRequest, isDirty: boolean, reset?: UseFormReset<InterestRatesRequest>) {
    if (!isDirty) {
      return;
    }

    setIsLoading(true);
    setHasError(false);

    try {
      const responseData = await fetchInterestRates({
        ...data,
        partnership: getPartnership(data.partnership),
      });
      setResponseData(responseData);
      trackCalculatorSubmit(data.loanAmount, data.partnership ?? 'none');
      setIsLoading(false);

      reset?.(data);
    } catch (_e) {
      setIsLoading(false);
      setHasError(true);
    }
  }

  const handleFormChange = () => {
    setResponseData(null);
  };
  const isMobile = isExtraSmall || isSmall;
  return (
    <BaseLayout>
      <FormLayout height={isMobile ? 'auto' : '100%'}>
        <Form
          onSubmit={onSubmit}
          buttonRef={buttonRef}
          responseData={responseData}
          onFormChange={handleFormChange}
          loading={isLoading}
        />
      </FormLayout>
      <ResultLayout
        isHidden={isMobile && !responseData && !isLoading && !hasError}
        focus={isMobile && !!responseData}
        withSeparator={!isMobile}
        withBorder={false}
      >
        <Results data={responseData} isLoading={isLoading} hasError={hasError} />
      </ResultLayout>
    </BaseLayout>
  );
}
